import React, { useState, useEffect } from 'react';
import moment from 'moment';
import './ReportPage.css';
import Conect from '../../../../Api/Conect';
import { Container, Table } from 'react-bootstrap';
import NotificationsAlert from '../../../services/NotificationsAlert';
import LoadingOverlayManager from '../../../services/LoadingOverlayManager';

import { FaCheck, FaMinus } from "react-icons/fa";


const ReportPage = () => {
    const token = localStorage.getItem("restoken");
    const fusoUser = localStorage.getItem('resstateFuso');
    const id_cli = localStorage.getItem('resid_cli');

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [vehicleId, setVehicleId] = useState('');
    const [vehicles, setVehicles] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [trip, setTrip] = useState(0);


    useEffect(() => {
        const setInitialDates = () => {
            setStartDate(moment().startOf('day').format('YYYY-MM-DDTHH:mm'));
            setEndDate(moment().endOf('day').format('YYYY-MM-DDTHH:mm'));
        };

        const getVehicles = async () => {
            if (token && id_cli) {
                try {
                    const response = await Conect.post(`/dmVoaWNsZXNDbGllbnRMaXN0${token}`, { id_cli });
                    if (response.data.erro) {
                        NotificationsAlert("warning", "Atenção", response.data.msg);
                    } else {
                        setVehicles(response.data.vehicles || []);
                    }
                } catch (error) {
                    console.error("Erro ao buscar veículos:", error);
                }
            }
        };

        setInitialDates(); // Defina as datas inicialmente
        getVehicles(); // Busque as posições dos veículos
    }, [token, id_cli]);

    const handleSubmit = async (e) => {
        setReportData([])
        LoadingOverlayManager.show();

        e.preventDefault();
        const HR_INICIAL = moment(startDate, "YYYY-MM-DDTHH:mm").format("HH:mm:ss");
        const DT_INICIAL = moment(startDate, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD");

        const HR_FINAL = moment(endDate, "YYYY-MM-DDTHH:mm").format("HH:mm:ss");
        const DT_FINAL = moment(endDate, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD");


        let hrInicial = moment(HR_INICIAL, 'HH:mm:ss').add(3, 'hours').format('HH:mm:ss');
        let hrFinal = moment(HR_FINAL, 'HH:mm:ss').add(3, 'hours').format('HH:mm:ss');
        let dtFinal = moment(DT_FINAL).add(1, 'day').format('YYYY-MM-DD');

        const data = {
            id: vehicleId,
            startDate: `${DT_INICIAL} ${hrInicial}`,
            endDate: `${dtFinal} ${hrFinal}`,
        };

        try {

            const response = await Conect.post(`/b2xkcG9zaXRpb25z${token}`, data);
            if (!response.data.erro) {
                LoadingOverlayManager.hide();
                var dados = response.data.vehiclePosition.map((value, index) => {
                    let link = `https://www.google.com.br/maps/place/${value.latitude},${value.longitude}`
                    let res = response.data.vehiclePosition
                    var trip = ((res[res.length - 1].odometerGps) - res[0].odometerGps)
                    setTrip(trip)

                    return (<tr style={{ color: "#fff", fontSize: 14 }} key={index}>
                        <td>{index + 1}</td>
                        <td style={{ marginRight: 5 }}>{value.plate}</td>
                        <td>{`${moment(value.dateTime).subtract(Math.abs(fusoUser), "hours").format("DD/MM/yyyy")} - ${moment(value.dateTime).subtract(Math.abs(fusoUser), "hours").format("HH:mm:ss")}`}</td>
                        <td>{value.nearDesc}</td>
                        <td>{value.speed.toFixed(0)} Km/h</td>
                        <td>{String(value.odometerGps / 1000).substring(0, 7)}</td>
                        <td>{value.extPower} V</td>
                        <td>{value.ignition === 1 ?
                            <FaCheck style={{ marginLeft: 5, fontSize: 25, color: '#0f0' }} />
                            :
                            <FaMinus style={{ marginLeft: 5, fontSize: 25, color: '#f00' }} />
                        }
                        </td>
                        <td>{value.output2 === 1 ?
                            <FaCheck style={{ marginLeft: 5, fontSize: 25, color: '#0f0' }} />
                            :
                            <FaMinus style={{ marginLeft: 5, fontSize: 25, color: '#f00' }} />
                        }
                        </td>
                        <td>
                            <a href={link}>
                                {value.latitude.toFixed(3)}/{value.longitude.toFixed(3)}
                            </a>
                        </td>
                    </tr>)

                })
                LoadingOverlayManager.hide();
                setReportData(dados)
            }
        } catch (error) {
            LoadingOverlayManager.hide();
            console.error("Erro ao solicitar o relatório:", error);
        }
    };

    return (
        <div className="report-page">
            <div className="report-form">
                <h5 style={{ color: '#fff', marginTop: 15 }}>Relatório De Posições</h5>
                <label style={{ color: '#fff' }} htmlFor="startDate">Inicio:</label>
                <input
                    type="datetime-local"
                    id="startDate"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                />

                <label style={{ color: '#fff' }} htmlFor="endDate">Final:</label>
                <input
                    type="datetime-local"
                    id="endDate"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                />

                <label style={{ color: '#fff' }} htmlFor="vehicleId">Veículo:</label>
                <select
                    id="vehicleId"
                    value={vehicleId}
                    onChange={(e) => setVehicleId(e.target.value)}
                >
                    <option value="">Selecione um veículo</option>
                    {vehicles.map(vehicle => (
                        vehicle.type !== "NEW" && (
                            <option key={vehicle.id} value={vehicle.id}>
                                {vehicle.plate}
                            </option>
                        )
                    ))}
                </select>
                <button onClick={handleSubmit} className="submit-btn">Solicitar Relatório</button>
                {reportData && (<label style={{ color: '#fff', marginTop: "5px" }}>Trip: {(trip / 1000).toFixed(2)}Km</label>)}

            </div>

            <>

                {
                    reportData.length > 0 &&
                    <Container>
                        <div style={{
                            width: "100%",
                            overflowX: 'hidden'
                        }}>

                            <Table className="vehicle-table" responsive>
                                <thead style={{ fontSize: 14 }}>
                                    <tr style={{ color: '#fff' }}>
                                        <th>#</th>
                                        <th>Placa</th>
                                        <th>Data e Hora</th>
                                        <th>Localização</th>
                                        <th>Velocidade</th>
                                        <th>Hodometro</th>
                                        <th>Ext Power</th>
                                        <th>Ignição</th>
                                        <th>Bloqueio</th>
                                        <th>Localização</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportData}
                                </tbody>
                            </Table>
                        </div>
                    </Container>
                }


            </>
        </div>
    );
};

export default ReportPage;
